import React, { forwardRef } from 'react';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string | React.ReactNode;
  error?: string;
  helperText?: string;
}

export const Input = forwardRef<HTMLInputElement, InputProps & { rightElement?: React.ReactNode; leftElement?: React.ReactNode }>(
  ({ label, error, helperText, className = '', rightElement, leftElement, ...props }, ref) => {
    return (
      <div className="w-full">
        {label && (
          <label className="block text-sm font-medium text-gray-700 mb-2">
            {label}
          </label>
        )}
        <div className="relative">
          {leftElement && (
            <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
              {leftElement}
            </div>
          )}
          <input
            ref={ref}
            className={`
              w-full px-4 py-3 rounded-lg border-2 border-[#E5E7EB] transition-all duration-200
              ${leftElement ? 'pl-10' : ''}
              ${rightElement ? 'pr-12' : ''}
              ${error
                ? 'border-red-500 focus:border-red-600 focus:ring-red-500/20'
                : 'border-gray-200 focus:border-hprimary-500 focus:ring-hprimary-500/20'
              }
              focus:outline-hidden focus:ring-4
              placeholder:text-gray-400
              disabled:bg-gray-50 disabled:cursor-not-allowed
              ${className}
            `}
            {...props}
          />
          {rightElement && (
            <div className="absolute inset-y-0 right-0 flex items-center pr-3">
              {rightElement}
            </div>
          )}
        </div>
        {error && (
          <p className="mt-2 text-sm text-red-600">{error}</p>
        )}
        {helperText && !error && (
          <p className="mt-2 text-sm text-gray-500">{helperText}</p>
        )}
      </div>
    );
  }
);

Input.displayName = 'Input';

